//正式需修改部分
global.getQpServer = function (){
	var domain;
	if(document.domain == 'www.leba.com' || document.domain == 'tg.leba.com' || document.domain == 'dnh5.leba.com' || document.domain == 'wxtg.leba.com'){	//外网
		domain = 'https://dnapi.leba.com/index.php';
	}else if(document.domain == 'dnh5test1.leba.com'){	//预发布环境
		domain = 'https://dntest1api.leba.com/index.php';
	}else if(document.domain == 'dnh5test.leba.com'){	//测试
		domain = 'https://dntest201api.leba.com/index.php';
	}else{	//开发
		domain = 'https://api.mj.5sm.com/index.php';
	}
	return domain;
}

global.getHeadUrl = function (){
	var domain;
	if(document.domain == 'www.leba.com' || document.domain == 'tg.leba.com' || document.domain == 'dnh5.leba.com' || document.domain == 'wxtg.leba.com'){	//外网
		domain = 'https://dnapi.leba.com/index.php';
	}else if(document.domain == 'dnh5test1.leba.com'){	//预发布环境
		domain = 'https://dntest1api.leba.com/index.php';
	}else if(document.domain == 'dnh5test.leba.com'){	//测试
		domain = 'https://dntest201api.leba.com/index.php';
	}else{	//开发
		domain = 'http://172.29.151.206:90/';
	}
	return domain;
}

//分享网页时请求图标用
global.getHost = function (serverType){
	var domain;
	if(document.domain == 'www.leba.com'){	//外网1
		domain = 'https://www.leba.com';
	}else if(document.domain == 'tg.leba.com'){	//外网2
		domain = 'https://tg.leba.com';
	}else if(document.domain == 'dnh5.leba.com'){	//外网3
		domain = 'https://dnh5.leba.com';
	}else if(document.domain == 'wxtg.leba.com'){	//外网4
		domain = 'https://wxtg.leba.com';
	}else if(document.domain == 'dnh5test1.leba.com'){	//预发布环境
		domain = 'https://dnh5test1.leba.com';
	}else if(document.domain == 'dnh5test.leba.com'){	//测试
		domain = 'https://dnh5test.leba.com';
	}else{	//开发
		domain = 'https://172.29.151.206:96';
	}
	return domain;
}
//微信分享
import wx from 'weixin-js-sdk'
global.getWXJS=function(context,shareTitle,shareLink,shareContent){
	if (isWeiXin) {
		var _this=context;
		var href = window.location.href;
		href = encodeURIComponent(href);
		var url=getQpServer()+'/H5/weixin/weixinInfo?url='+href;
		_this.$ajax({
			method : 'get',
			url : url,
		}).then(function(response){
			if (response.data.success == 1) {
				var data=response.data.data;
				wx.config({
					debug: false,
    						appId: data.appId, // 必填，公众号的唯一标识
    						timestamp: data.timestamp, // 必填，生成签名的时间戳
    						nonceStr: data.noncestr, // 必填，生成签名的随机串
    						signature: data.signature,// 必填，签名，见附录1
    						jsApiList: ['onMenuShareTimeline','onMenuShareAppMessage'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
    					});
				wx.ready(function(){
					wx.onMenuShareTimeline({
    							title: shareContent, // 分享标题
    							link: shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
   								imgUrl: getHost()+'/ic_launcher.png', // 分享图标
   								success: function () { 
   								},
   								cancel: function () { 
   								}
   							});
					wx.onMenuShareAppMessage({
    							title: shareTitle, // 分享标题
    							desc: shareContent, // 分享描述
    							link: shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    							imgUrl: getHost()+'/ic_launcher.png', // 分享图标
    							type: 'link', // 分享类型,music、video或link，不填默认为link
    							dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
    							success: function () { 
    							},
    							cancel: function () { 
    							}
    						});
				});
				wx.error(function(res){
				});
			}
		},function(response){});
	}
}
//是否在微信
global.isWeiXin=function (){
	var ua = window.navigator.userAgent.toLowerCase();
	if(ua.match(/MicroMessenger/i) == 'micromessenger'){
		return true;
	}else{
		return false;
	}
}
//是否是iphoneX
global.isIphoneX=function(){
    return /iphone/gi.test(navigator.userAgent) && (screen.height == 812 && screen.width == 375)
}

//跳到APPSTORE
global.goToAppStore=function(){
	window.location.href='itms-services://?action=download-manifest&url=https://down.5sm.com/manifest.plist';
}


//////////////////
// WEBPACK FOOTER
// ./static/js/util.js
// module id = 143
// module chunks = 9